const Lite_loader = {
  LITE_LOADER_TRUE: 'LITE_LOADER_TRUE',
  LITE_LOADER_FALSE: 'LITE_LOADER_FALSE',
};

export default Lite_loader;
